import { render, staticRenderFns } from "./channelItem2.vue?vue&type=template&id=4c8dd3c2&"
import script from "./channelItem2.vue?vue&type=script&lang=ts&"
export * from "./channelItem2.vue?vue&type=script&lang=ts&"
import style0 from "./channelItem2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports